import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface FullBenefitCode {
  codeId: number,
  description: string,
  isRepeated: boolean
  isDisabled: boolean
}

export interface BenefitKey {
  [index:string]: FullBenefitCode
}
export interface TimeSheetBenefitCodesState {
    benefitCodes: BenefitKey
  }

const initialState: TimeSheetBenefitCodesState = {
    benefitCodes: {
      key: {
        codeId: 0,
        description: '',
        isRepeated: false,
        isDisabled: false
      }
    }

}
export const timesheetApprovalBenefitCodeSlice = createSlice({
    name: 'timesheetApprovalBenefitCodes',
    initialState,
    reducers: {
      approvalChangeBenefits: (state, action: PayloadAction<TimeSheetBenefitCodesState>) => {
        state.benefitCodes = action.payload.benefitCodes
      }
    }
});

export const { approvalChangeBenefits } = timesheetApprovalBenefitCodeSlice.actions